import React from 'react';
import { isEmpty, map } from 'lodash';
import { makeStyles } from '@material-ui/core';
import MenuProvider from './MenuProvider';
import { useSnackbarContext } from '../contexts/menuToast';

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    textAlign: 'left',
    width: '100%',
    flexWrap: 'wrap',
  },
  item: {
    flexBasis: '100%',
    overflow: 'hidden',
    padding: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      flexBasis: '50%',
    },

    [theme.breakpoints.up('md')]: { flexBasis: '33.3%' },
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 20,
    padding: theme.spacing(4, 0),
    textAlign: 'center',
    width: '100%',
  },
}));

const DailyMenuPage = ({
  data,
  onProductClick,
  showInventoryStatusSign,
}) => {
  const { snackbar } = useSnackbarContext();
  const classes = useStyle();

  return (
    <>
      {snackbar}
      <div className={classes.root}>
        {isEmpty(data) && (
          <div className={classes.empty}>
            <span>本日尚無法訂購</span>
            <span>coming soon</span>
            <span>敬請期待</span>
          </div>
        )}
        {map(data, (item) => {
          const {
            coverImage,
            description,
            id,
            introduction,
            name,
            products,
            provider: providerName,
          } = item || {};

          const images = coverImage;

          return (
            <div className={classes.item} key={id}>
              <MenuProvider
                data={item}
                images={images}
                introduction={introduction || description || ''}
                onProductClick={onProductClick}
                products={products || []}
                providerName={providerName || name || ''}
                showInventoryStatusSign={showInventoryStatusSign}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DailyMenuPage;
